<template>
	<div class="grid-comp">
		<div class="grid-title">
			{{orderName}}  <span v-if="reportName === 'goodCustomDetail'">- 客户明细</span>
			<span v-if="reportName === 'customGoodDetail'">- 商品明细</span>
			<span v-if="detailType === 'order'">- 已订货客户明细</span>
			<span v-if="detailType === 'unorder'">- 未订货客户明细</span>
			<el-tooltip effect="dark" placement="right" popper-class="tip-class">
				<div slot="content">
					<span v-if="reportName === 'goodMarketNew' || reportName === 'customGoodDetail' || reportName === 'orderCustomDetail'">1、记录订单生成时的商品属性，后续属性变更会新生成一条统计明细；如下单<br>时苹果规格是斤，下单后变更为克，再次下单苹果会生成一条新的统计明细，<br>不会变更已生成的明细中规格名称，其他属性同理。<br>
</span>
					<span v-if="reportName === 'goodCustomDetail' || reportName === 'customSaleNew'">1、记录订单/退单生成时的客户属性，后续属性变更会新生成一条统计明细；如下单<br>时张三客户类别是东北区，下单后变更为华北区，再次下单张三会生成一条新的客户<br>类别为华北区的统计明细，不会变更已生成的明细中客户类别，其他属性同理。<br>
					</span>
					2、提交订单/退单即记录计入统计<br>
					3、作废的订单/退单不计入统计<br>
					4、金额为营销活动优惠后的金额，运费不计入统计<br>
					<span v-if="reportName === 'goodMarketNew' || reportName === 'customGoodDetail' || reportName === 'orderCustomDetail'">5、想查询商品总数据可把明细列（如规格）隐藏点击查询即可汇总查询总数据<br></span>
					<span v-if="reportName === 'goodCustomDetail' || reportName === 'customSaleNew'">5、想查询客户总数据可把明细列（如客户类别）隐藏点击查询即可汇总查询总数据<br></span>
					<span v-if="reportName === 'orderCustomDetail'">6、统计订单商品数量<span>{{detailType === 'order' ? '大于' : '等于'}}</span>0的客户明细</span>
				</div>
				<img src="~/images/icon/tooltip-icon.png" class="tip-icon">
			</el-tooltip>
		</div>
		<div class="grid-wrap">
			<div class="data-box">
				<div class="data-item">
					<div class="data-title">订单数量</div>
					<div class="data-num">{{sumdata.orderidcount}}</div>
				</div>
				<div class="data-item">
					<div class="data-title">订单商品数量</div>
					<div class="data-num">{{sumdata.livequantity}}</div>
				</div>
				<div class="data-item">
					<div class="data-title">订单商品金额</div>
					<div class="data-num">{{sumdata.livemoney}}</div>
				</div>
				<div class="data-item" v-if="reportName !== 'orderCustomDetail'">
					<div class="data-title">退单数量</div>
					<div class="data-num">{{sumdata.refundidcount}}</div>
				</div>
				<div class="data-item" v-if="reportName !== 'orderCustomDetail'">
					<div class="data-title">退单商品数量</div>
					<div class="data-num">{{sumdata.refundquantity}}</div>
				</div>
				<div class="data-item" v-if="reportName !== 'orderCustomDetail'">
					<div class="data-title">退单商品金额</div>
					<div class="data-num">{{sumdata.refundmoney}}</div>
				</div>
				<div class="data-item data-unSell" v-if="reportName === 'goodMarketNew'">
					<div class="data-title">未销售商品
						<el-tooltip effect="dark" placement="right" popper-class="tip-class">
							<div slot="content">
								1、统计查询时间内订单商品数量为0的商品<br>
								2、作废的订单不记录统计<br>
								3、按商品规格（SKU）维度统计
							</div>
							<img src="~/images/icon/tooltip-icon.png" class="tip-icon">
						</el-tooltip>
					</div>
					<div class="data-num" @click="goUnSellDetail">{{sumdata.unproductsalecount}}</div>
				</div>
			</div>
			<div id="myChart" style="height:320px;"></div>
			<el-table
				ref='table'
				class="grid-content"
				row-class-name="fx-cursor"
				:data="tableData"
				row-key="number"
				show-summary
				header-cell-class-name='is-header-cell'
				:summary-method="sumhandle"
				@row-dblclick="goDetail"
				@header-dragend='headerDragend'
				@sort-change="sortChangeHandle"
				border
				max-height="800px">
				<el-table-column
					:fixed="true"
					label-class-name = "column-index"
					label="序号"
					type="index"
					width="70"
					align="center"
					v-if="showIndex">
				</el-table-column>
				<template v-for="(item, index) in dropCol">
					<el-table-column
						v-if="item.showFlag && (item.prop === 'customercount' || item.prop === 'uncustomercount')"
						:label-class-name="`fx-table-column fx-drog-${item.prop}`"
						:key="`col_${index}`"
						:prop="dropCol[index].prop"
						:width="item.width"
						:label="item.label"
						:fixed = "item.fixed"
						:align="item.align"
						:show-overflow-tooltip = "true"
						:header-align = "item.headerAlign"
						:sortable='item.sortable'
						:formatter="item.formatter">
						<template slot-scope="scope">
							<div v-show="item.prop === 'customercount'" class="link-btn" @click="goOrderGoodsDetail(scope.row, 'order')">{{scope.row.customercount}}</div>
							<div v-show="item.prop === 'uncustomercount'" class="link-btn" @click="goOrderGoodsDetail(scope.row, 'unorder')">{{scope.row.uncustomercount}}</div>
						</template>
					</el-table-column>
					<el-table-column
						v-if="item.showFlag && !(item.prop === 'customercount' || item.prop === 'uncustomercount')"
						:label-class-name="`fx-table-column fx-drog-${item.prop}`"
						:key="`col_${index}`"
						:prop="dropCol[index].prop"
						:width="item.width"
						:label="item.label"
						:fixed = "item.fixed"
						:align="item.align"
						:show-overflow-tooltip = "true"
						:header-align = "item.headerAlign"
						:sortable='item.sortable'
						:formatter="item.formatter">
					</el-table-column>
				</template>
				<el-table-column
					v-if="reportName === 'goodMarketNew'"
					label="操作"
					type="index"
					width="130"
					align="center">
					<template slot-scope='scope'>
						<el-button type='text' size="mini" @click="goGoodsDetail(scope.row)">客户明细</el-button>
					</template>
				</el-table-column>
				<el-table-column
					v-if="reportName === 'customSaleNew'"
					label="操作"
					type="index"
					width="130"
					align="center">
					<template slot-scope='scope'>
						<el-button type='text' size="mini" @click="goCustomDetail(scope.row)">商品明细</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>
<script>
import { mapState } from 'vuex'

export default {
	name: 'GridComp',
	props: {
		tableData: {
			type: Array,
			default: () => []
		},
		pieData: {
			type: Array,
			default: () => []
		},
		gridCol: {
			type: Array,
			default: () => []
		},
		gridData: {
			type: Array,
			default: () => []
		},
		sumCol: {
			type: Object,
			default: () => {}
		},
		sumdata: {
			type: Object,
			default: () => {}
		},
		reportName: String,
		detailType: String
	},
	data () {
		return {
			dropCol: [],
			showIndex: true,
			menu: []
		}
	},
	mounted () {
		// this.drawPie()
		this.fxColumnDrop()
		this.getAuthority('09_0001_0000_00,09_0002_0000_00,09_0004_0000_00')
	},
	computed: {
		...mapState([
			'orderMenu',
			'orderName',
			'throughPath',
			'throughParams'
		])
	},
	watch: {
		gridCol: {
			handler (val) {
				let temp = []
				this.dropCol = JSON.parse(JSON.stringify(val))
				this.dropCol.forEach((e) => {
					if (e.showFlag) {
						temp.push(e)
					}
				})
				if (temp.length === 0) {
					this.showIndex = false
				} else {
					this.showIndex = true
				}
				this.$nextTick(() => {
					this.initDrogCell()
				})
			},
			immediate: true
		},
		tableData: {
			handler (val) {
				this.$nextTick(() => {
					this.$refs.table.doLayout()
				})
				// console.log(val)
			},
			immediate: true
		},
		// pieData: {
		// 	handler (val) {
		// 		// console.log(val)
		// 	},
		// 	immediate: true
		// },
		gridData () {
			this.$nextTick(() => {
				this.initDrogCell()
			})
		}
	},
	// updated () {
	// 	this.$nextTick(() => {
	// 		this.$refs.table.doLayout()
	// 	})
	// },
	methods: {
		drawPie () {
			// var echarts = require('echarts')
			let myChart = this.$echarts.init(document.getElementById('myChart'))
			let colors = this.pieData[0].name === '暂无数据' ? ['#eee'] : ['#ee6666', '#91cc75', '#fac858', '#5470c6', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc', '#ffdb5c', '#ee6666', '#91cc75', '#fac858', '#5470c6', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc', '#ECF0F3']
			let that = this
			// let data = this.getData(20)
			let option = {
				// title: {
				// 	text: '同名数量统计',
				// 	subtext: '纯属虚构',
				// 	left: 'center'
				// },
				tooltip: {
					trigger: 'item',
					extraCssText: 'text-align: left;',
					formatter: '{b}<br/>数值:{c}<br/>占比:{d}%'
				},
				color: colors,
				legend: {
					// type: '',
					orient: 'vertical',
					data: this.pieData,
					height: 250,
					right: 50,
					top: 'middle',
					// with: 10000,
					// bottom: 120,
					formatter: function (name) {
						let target, nameDot
						for (let i = 0; i < that.pieData.length; i++) {
							let item = that.pieData[i]
							if (item.name === name) {
								nameDot = item.nameDot
								target = item.value
							}
						}
						var arr = [
							'{a|' + nameDot + '}',
							'{b|' + target + '}'
						]
						return arr.join('  ')
					},
					textStyle: {
						// with: 800,
						// height: 100,
						padding: [0, 0, 0, 10],
						rich: {
							a: {
								fontSize: 14,
								width: 240
							},
							b: {
								fontSize: 14,
								width: 110
								// color: '#c1c1c1'
							}
						}
					}
				},
				series: [
					{
						name: '姓名',
						type: 'pie',
						radius: '85%',
						center: ['20%', '50%'],
						data: this.pieData,
						label: { // 展示文本设置
							normal: {
								show: false// 展示
							}
						},
						labelLine: { // 引导线设置
							normal: {
								show: false // 引导线显示
							}
						},
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}
				]
			}
			myChart.setOption(option, true)
			myChart.on('click', function (param) {
				// console.log(param)
				if (that.reportName === 'goodMarketNew' && param.data.name !== '暂无数据' && param.data.name !== '20、其他') {
					that.goGoodsDetail(param.data)
				}
				if (that.reportName === 'customSaleNew' && param.data.name !== '暂无数据' && param.data.name !== '20、其他') {
					that.goCustomDetail(param.data)
				}
			})
		},
		goDetail (row) {
			if (this.reportName === 'goodMarketNew') {
				this.goGoodsDetail(row)
			}
			if (this.reportName === 'customSaleNew') {
				this.goCustomDetail(row)
			}
		},
		goGoodsDetail (row) {
			let query = {
				pname: { field: 'pname', op: 'eq', type: 'filtersParams', value: row.pname },
				spec: { field: 'spec', op: 'eq', type: 'filtersParams', value: row.spec }
			}
			if (typeof this.$attrs.getCustomThroughParams === 'function') {
				let customThroughParams = this.$attrs.getCustomThroughParams()
				if (Array.isArray(customThroughParams)) {
					customThroughParams.forEach(item => {
						query[item.name] = item
					})
				}
			}
			this.$router.push({
				path: '/reportform/goodCustomDetail',
				query: { throughParams: encodeURI(JSON.stringify(query)) }
			}, this.$router)
		},
		goOrderGoodsDetail (row, targetName) {
			let query = {
				pname: { field: 'pname', op: 'eq', type: 'filtersParams', value: row.pname },
				spec: { field: 'spec', op: 'eq', type: 'filtersParams', value: row.spec }
			}
			if (typeof this.$attrs.getCustomThroughParams === 'function') {
				let customThroughParams = this.$attrs.getCustomThroughParams()
				if (Array.isArray(customThroughParams)) {
					customThroughParams.forEach(item => {
						query[item.name] = item
					})
				}
			}
			this.$router.push({
				path: '/reportform/orderCustomDetail',
				query: { throughParams: encodeURI(JSON.stringify(query)), target: targetName }
			}, this.$router)
		},
		goCustomDetail (row) {
			let query = {
				customerName: { field: 'customerName', op: 'eq', type: 'filtersParams', value: row.customerName }
				// customercategoryid: { field: 'customercategoryid', op: 'in', type: 'cParams', value: row.customercategoryid }
			}
			if (typeof this.$attrs.getCustomThroughParams === 'function') {
				let customThroughParams = this.$attrs.getCustomThroughParams()
				if (Array.isArray(customThroughParams)) {
					customThroughParams.forEach(item => {
						query[item.name] = item
					})
				}
			}
			this.$router.push({
				path: '/reportform/customGoodDetail',
				query: {
					throughParams: encodeURI(JSON.stringify(query))
				}
			}, this.$router)
		},
		goUnSellDetail () {
			let query = {}
			if (typeof this.$attrs.getCustomThroughParams === 'function') {
				let customThroughParams = this.$attrs.getCustomThroughParams()
				if (Array.isArray(customThroughParams)) {
					customThroughParams.forEach(item => {
						query[item.name] = item
					})
				}
			}
			this.$router.push({
				path: '/reportform/unSellGoods',
				query: { throughParams: encodeURI(JSON.stringify(query)) }
			}, this.$router)
		},
		headerDragend () {
			this.$nextTick(() => {
				this.$refs.table.doLayout()
			})
		},
		getWidth () {
			let list = document.querySelectorAll('.is-header-cell')
			let arr = []
			list.forEach(item => {
				arr.push(item.offsetWidth)
			})
			let num = (arr.length) / 2
			let tureArr = arr.slice(1, num)
			return tureArr
		},
		loadMore () {
			this.$emit('loadmore')
		},
		getAuthority (pid) {
			let params = {
				pId: pid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					let menu = this.orderMenu
					for (let i = 0; i < a.length; i++) {
						for (let j = 0; j < menu.length; j++) {
							if (a[i] === menu[j].authority) {
								menu[j].show = true
							}
						}
					}
					this.menu = menu
				}
			})
		},
		initDrogCell () {
			const wrapperTr = document.querySelector('.el-table__header-wrapper tr')
			let children = wrapperTr.childNodes
			children.forEach(item => {
				item.draggable = true
				item.addEventListener('mouseover', function (e) {
					if (item.style.cursor === 'col-resize') {
						item.draggable = false
					} else {
						item.draggable = true
					}
				}, true)
			})
		},
		sumhandle (param) {
			let { columns } = param
			let sums = []
			let sumColArr = Object.keys(this.sumCol)
			columns.forEach((column, index) => {
				if (index === 0) {
					sums[index] = '总计'
					return false
				}
				if (sumColArr.includes(column.property) && this.sumCol[column.property] === 'sum') {
					// console.log(this.sumdata[column.property])
					// let values = this.gridData.map(item => {
					// 	return Number(item[column.property])
					// })
					// let sumValue = values.reduce((pre, cur) => {
					// 	return pre + cur
					// }, 0)
					let sumValue = this.sumdata[column.property]
					sums[index] = sumValue
				}
			})
			this.$nextTick(() => {
				this.$refs.table.doLayout()
			})
			return sums
		},
		getSumCols () {
			let columns = this.gridCol.filter(item => {
				return item.showFlag === true
			})
			let sums = {}
			let sumColArr = Object.keys(this.sumCol)
			if (sumColArr.length === 0) {
				return sums
			}
			columns.forEach((column, index) => {
				if (sumColArr.includes(column.prop) && this.sumCol[column.prop] === 'sum') {
					let values = this.gridData.map(item => {
						return Number(item[column.prop])
					})
					let sumValue = values.reduce((pre, cur) => {
						return pre + cur
					}, 0)
					sums[column.prop] = this.$fxUtils.toFixedSHW(sumValue, 2)
				}
			})
			return sums
		},
		fxColumnDrop () {
			this.$nextTick(() => {
				const wrapperTr = document.querySelector('.el-table__header-wrapper tr')
				let dragDom = null
				wrapperTr.addEventListener('dragstart', (e) => {
					e.stopPropagation()
					dragDom = e.target
				}, true)
				wrapperTr.addEventListener('dragover', (e) => {
					e.stopPropagation()
					e.preventDefault()
				}, true)
				wrapperTr.addEventListener('drop', (e) => {
					e.stopPropagation()
					if (dragDom !== e.target) {
						e.target.classList.remove('drog-active')
						let newIndex = this.getDrogTrueIndex(e.target)
						let oldIndex = this.getDrogTrueIndex(dragDom)
						this.dropCol.splice(newIndex, 0, this.dropCol.splice(oldIndex, 1)[0])
						this.$emit('update:gridCol', this.dropCol)
						this.$emit('dropCol')
					}
				}, true)
				wrapperTr.addEventListener('dragenter', (e) => {
					e.stopPropagation()
					if (e.target.className.indexOf('fx-table-column') !== -1) {
						if (dragDom !== e.target) {
							e.target.classList.add('drog-active')
						}
					}
				}, true)
				wrapperTr.addEventListener('dragleave', (e) => {
					e.stopPropagation()
					if (e.target.className.indexOf('fx-table-column') !== -1) {
						if (dragDom !== e.target) {
							e.target.classList.remove('drog-active')
						}
					}
				}, true)
			})
		},
		rowClickHandle (row, event, column) {
			if (this.throughPath !== '') {
				if (row.ordertype === '退单') {
					return false
				}
				if (this.orderName === '单据支付对账明细表' || this.orderName === '支付流水报表') {
					if (row.ordernumber === '' && row.refundnumber === '') {
						return false
					}
				}
				let list = this.menu
				let flag = 0
				var throughName = ''
				for (let i = 0; i < list.length; i++) {
					if (list[i].path === this.throughPath) {
						throughName = list[i].label
						if (list[i].show === true) {
							flag++
						}
					}
				}
				if (flag > 0) {
					let query = {}
					if (this.orderName === '活动类型汇总表') {
						this.throughParams.forEach(item => {
							let paramObj = {
								field: item.field,
								op: item.op,
								value: row[item.field] === '满减' ? '0' : '1',
								type: item.type
							}
							query[item.field] = paramObj
						})
					} else {
						this.throughParams.forEach(item => {
							let paramObj = {
								field: item.field,
								op: item.op,
								value: row[item.field],
								type: item.type
							}
							query[item.field] = paramObj
						})
					}
					if (typeof this.$attrs.getCustomThroughParams === 'function') {
						let customThroughParams = this.$attrs.getCustomThroughParams()
						if (Array.isArray(customThroughParams)) {
							customThroughParams.forEach(item => {
								query[item.name] = item
							})
						}
					}
					let app = window.sessionStorage.getItem('app')
					if (app === 'scm8') {
						let queryText = {
							throughParams: encodeURI(JSON.stringify(query))
						}
						let params = {
							app: 'jsd',
							action: 'goBlank',
							data: {
								path: 'reportform/' + this.throughPath,
								query: queryText,
								id: '11',
								title: '报表'
							}
						}
						window.parent.postMessage(params, '*')
					} else {
						this.$fxGoBlank({
							path: this.throughPath,
							query: { throughParams: encodeURI(JSON.stringify(query)) }
						}, this.$router)
					}
				} else {
					this.$message.error({
						message: `您没有查看${throughName}报表的权限!`
					})
				}
			}
		},
		getDrogTrueIndex (target) {
			let prop = [].find.call(target.classList, (item) => {
				return /^fx-drog-/.test(item)
			})
			if (prop) {
				prop = prop.replace(/^fx-drog-/, '')
				let index = this.gridCol.findIndex(item => {
					return item.prop === prop
				})
				return index
			} else {
				return 0
			}
		},
		sortChangeHandle (column) {
			this.$emit('sort-change', column)
		},
		getCurrentCols () {
			return this.dropCol
		}
	}
}
</script>
<style lang="stylus" scoped>
@import '~$assets/stylus/varsty.styl'
.grid-comp {
	min-height :0;
	width: 100%;
	flex: 1;
	display: flex;
	flex-direction: column;
	.grid-title {
		height: 40px;
		line-height: 40px;
		border-bottom: 1px solid #eee;
		text-align: left;
		padding-left: 20px;
		position:relative
		font-size:16px
		font-weight:700
		&::before {
			content: ''
			position:absolute
			height:20px
			width:3px
			background:$fxDefaultColor
			top: 9px;
			left: 10px;
		}
	}
	.tip-icon {
		display: inline-block;
		margin-left: 5px;
		cursor: pointer
	}
	.grid-wrap {
		flex: 1;
		min-height :0;
		overflow: hidden auto
	}
	.data-box {
		display: flex
		width: 98%;
		margin: 20px auto;
		// justify-content: space-around;
		font-size: 15px;
		line-height: 30px;
		height: 90px;
		background: #f7f8fd;
		border: 1px solid #e2e7f0;
		.data-item {
			flex: 1;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			.data-title {
				colot: #666;
				display: flex;
				align-items: center;
			}
			.data-num {
				font-size: 18px;
				font-weight: bold
			}
		}
		.data-unSell {
			position: relative
			&::before {
				content: ''
				position:absolute
				height:50px
				width:1px
				background: #999
				top: 20px;
				left: 0px;
			}
			.data-num {
				color: var(--fx-primary-color);
				cursor: pointer
			}
		}
	}
	.grid-content {
		// flex: 1;
		// min-height: 200px;
		width: 98%;
		margin: 20px auto;
	}
}
.link-btn {
	color: var(--fx-primary-color)
}
</style>
<style lang="stylus">
.grid-content th, .grid-content td{
	padding:5px 0 !important
}
.grid-content th {
	&.drog-active {
		color:#fff
		background-color:#eee
	}
	* {
		pointer-events: none
	}
}
.fx-drog-memorypremoney,.fx-drog-realpremoney,.fx-drog-lockpremoney,.fx-drog-realpremoneyafter{
	* {
		pointer-events: all !important
	}
}
.grid-comp .el-table__footer td {
	text-align: right !important
}
.el-table--scrollable-x .el-table__body-wrapper {
	z-index: 2;
}
</style>
